var $ = require('jquery');
require('slick-carousel');

function init() {
    var $slickElements = $('.pt_register_new .registration-benefits ul');
    var $slickElement = $('.pt_register_new .registration-benefits ul li');
    var $errorForm = $('.error-form');
    var loginErr = $('.error-msg');
    var loginForm = $('#RegistrationForm');
    var $validationError = $('.validation-error');
    var $registrationForm = $('#registration-form-wrapper');
    var $termsAndConditionsBtn = $('.create-account-terms');
    var $allLegalTerms = $('.all-legal-terms');
    var $promotionalConsent = $('.registration-promotional-consent');
    var $smsSignUpCheckbox = $('#dwfrm_profile_customer_acceptsmssignup');
    var $inputSignUpSms = $('.input-signUp-sms');
    var slickElementsCount = $slickElement.length;
    var optionsRegistrationSlider;
    var util = require('../utils/util');

    if (slickElementsCount > 3) {
        optionsRegistrationSlider = {
            lazyLoad: 'ondemand',
            infinite: true,
            autoplay: true,
            autoplaySpeed: 3000,
            slidesToShow: 3,
            slidesToScroll: 1,
            arrows: true,
            dots: false,
            dotsClass: 'slick-dots-custom',
            prevArrow:
                '<div class="slick-prev"><i class="icon icon-arrow_left" aria-label="next" tabindex="0"><!-- icon --></i></div>',
            nextArrow:
                '<div class="slick-next"><i class="icon icon-arrow_right" aria-label="next" tabindex="0"><!-- icon --></i></div>',
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        dots: true
                    }
                }
            ]
        };
    } else {
        optionsRegistrationSlider = {
            lazyLoad: 'ondemand',
            infinite: false,
            slidesToShow: 3,
            slidesToScroll: 1,
            arrows: true,
            dots: false,
            dotsClass: 'slick-dots-custom',
            prevArrow:
                '<div class="slick-prev"><i class="icon icon-arrow_left" aria-label="next" tabindex="0"><!-- icon --></i></div>',
            nextArrow:
                '<div class="slick-next"><i class="icon icon-arrow_right" aria-label="next" tabindex="0"><!-- icon --></i></div>',
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        dots: true
                    }
                }
            ]
        };
    }

    if ($smsSignUpCheckbox.length) {
        $smsSignUpCheckbox.on('click', function () {
            if ($smsSignUpCheckbox[0].checked) {
                $inputSignUpSms[0].style.display = 'block';
            } else {
                $inputSignUpSms[0].style.display = 'none';
            }
        });
    }

    $slickElements.slick(optionsRegistrationSlider);

    // Anchor link on the registration main teaser
    $(document).on('click', '.registration-main-teaser a[href^="#"]', function (event) {
        event.preventDefault();
        var $headerHeight = $('.header-wrapper');
        var $el = $($.attr(this, 'href'));

        if ($headerHeight.length && $el.length) {
            $('html, body').animate(
                {
                    scrollTop: $el.offset().top - $headerHeight.height()
                },
                800
            );
        }
    });

    function scrollToElement(ele) {
        var $headerHeight = $('.header-wrapper');
        if ($headerHeight.length && ele.length) {
            $('html, body').animate(
                {
                    scrollTop: ele.offset().top - $headerHeight.height()
                },
                800
            );
        }
    }

    if ($errorForm.length || ($validationError.length && $registrationForm.length)) {
        scrollToElement($registrationForm);
    }

    if (loginErr.length && $validationError.length && loginForm.length) {
        scrollToElement(loginForm);
    }

    util.toggleFormSubmitEnabled($termsAndConditionsBtn);

    $termsAndConditionsBtn.on('change', function () {
        util.toggleFormSubmitEnabled($termsAndConditionsBtn);
    });

    function addCheckedClass(element) {
        var $checker = $(element).closest('.checker');
        $checker.find('span').addClass('checked');
    }

    function removeCheckedClass(element) {
        var $checker = $(element).closest('.checker');
        $checker.find('span').removeClass('checked');
    }

    function toggleAllTermsCheckbox() {
        let unchecked = $(
            '.create-account-terms, .registration-promotional-consent, .create-account-checkout-terms'
        ).filter(function () {
            return !this.checked;
        });

        if (unchecked.length > 0) {
            removeCheckedClass($allLegalTerms);
        } else {
            addCheckedClass($allLegalTerms);
        }
    }

    $allLegalTerms.on('change', function () {
        var isChecked = $(this).prop('checked');

        $('.create-account-terms, .registration-promotional-consent, .create-account-checkout-terms').each(function () {
            $(this).prop('checked', isChecked);
            if (isChecked) {
                addCheckedClass(this);
            } else {
                removeCheckedClass(this);
            }
        });
        $termsAndConditionsBtn.trigger('change');
        $promotionalConsent.trigger('change');
    });

    $promotionalConsent.on('change', function () {
        var isChecked = $(this).prop('checked');

        $('.promotional-consent').each(function () {
            $(this).prop('checked', isChecked);
            if (isChecked) {
                addCheckedClass(this);
                toggleAllTermsCheckbox();
            } else {
                removeCheckedClass(this);
                removeCheckedClass($allLegalTerms);
            }
        });
    });

    $('.promotional-consent').on('change', function () {
        // Check if any checkbox is unchecked
        let unchecked = $('.promotional-consent').filter(function () {
            return !this.checked;
        });

        // If any checkbox is unchecked, alert the user
        if (unchecked.length > 0) {
            let elements = $allLegalTerms.add($promotionalConsent);
            removeCheckedClass(elements);
        } else {
            addCheckedClass($promotionalConsent);
            toggleAllTermsCheckbox();
        }
    });

    $('.create-account-terms, .create-account-checkout-terms').on('change', function () {
        // Check if any checkbox is unchecked
        let unchecked = $('.create-account-terms, .create-account-checkout-terms').filter(function () {
            return !this.checked;
        });

        // If any checkbox is unchecked, alert the user
        if (unchecked.length > 0) {
            removeCheckedClass($allLegalTerms);
        } else {
            unchecked = $('.promotional-consent').filter(function () {
                return !this.checked;
            });
            if (unchecked.length <= 0) {
                addCheckedClass($allLegalTerms);
            }
        }
    });
}

exports.init = init;
